import { useContext } from "react";
import { RNBridgeContext } from "../context/RNBridgeContext";

export const useRNBridge = () => {
    const context = useContext(RNBridgeContext);
    if (!context) {
        throw new Error('useRNBridge must be used within a RNBridgeProvider');
    }
    return context;
};